module.exports = __webpack_public_path__ + "static/media/078-belize.02f386f9.svg";